import {AfterContentInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {CurrentProductService} from '@spartacus/storefront';
import {NavigationLink} from '../navigation-bar/navigation-link';
import {ProductDetailsSectionComponent} from '../product-details-section/product-details-section.component';
import {ProductDetailsNavigationLinkService} from '../navigation-bar/product-details-navigation-link.service';
import {DcpBundleTemplate} from '@dcp/configurator';
import {NAV_LINK, PlansAndPricingDataService} from './plans-and-pricing-data.service';
import {DcpProductUtilitiesService} from '../../services/dcp-product-utilities.service';
import {ActivatedRoute} from '@angular/router';
import {CustomScrollingService} from '@app/services/custom-scrolling.service';
import {isPlatformBrowser} from '@angular/common';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-plans-and-pricing',
  templateUrl: './plans-and-pricing.component.html',
})
export class PlansAndPricingComponent extends ProductDetailsSectionComponent implements OnInit, OnDestroy, AfterContentInit {

  navLink: NavigationLink = NAV_LINK;

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    private route: ActivatedRoute,
    private customScrollingService: CustomScrollingService,
    protected dcpProductUtilitiesService: DcpProductUtilitiesService,
    protected currentProductService: CurrentProductService,
    protected changeDetection: ChangeDetectorRef,
    protected productDetailsNavigationLinkService: ProductDetailsNavigationLinkService,
    protected plansAndPricingDataService: PlansAndPricingDataService
  ) {
    super(currentProductService, changeDetection, productDetailsNavigationLinkService, dcpProductUtilitiesService);
  }

  get filteredBundleTemplates(): DcpBundleTemplate[] {
    return this.plansAndPricingDataService.sortBundles(this.product.bundleTemplates).filter(entry => !!entry?.data?.length);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  async ngAfterContentInit(): Promise<void> {
    super.ngAfterContentInit();

    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.route.fragment.pipe(untilDestroyed(this)).subscribe(async (fragment: string) => {
          if (fragment === 'pricing') {
            this.customScrollingService.scrollToElementId('plans-and-pricing-section', 70);
          }
        });
      }, 1000);
    }
  }

  isVisible(): boolean {
    return !!this.product?.bundleTemplates?.length;
  }
}
